import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { AuthContext } from '../contexts/AuthContext'

const RoleMiddleware = ({ roles, children }) => {
    const { kalviumKc } = useContext(AuthContext)
    if (kalviumKc.hasRole(roles)) {
        return children
    } else {
        return <Navigate to="/404" replace={true} />
    }
}

RoleMiddleware.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default RoleMiddleware
